"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CTABaseStyles = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const Primary_1 = __importDefault(require("../Primary"));
const CTA_BORDER_RADIUS = "30px";
exports.CTABaseStyles = (0, styled_components_1.css) `
  border-radius: ${CTA_BORDER_RADIUS};
  padding: 16px 40px;

  &:after {
    border-radius: ${CTA_BORDER_RADIUS};
  }

  @media only screen and (min-width: ${({ theme }) => `${theme.breakpoints.md}px`}) {
    body {
      padding: 16px 56px;
    }
  }
`;
/**
 * _Call to Action Button_
 *
 * The rounded call to action button should only be used in specific cases.
 * An example would be centered alignment of a button within a modal or dialog.
 *
 * **Scaling for responsive screen size:**
 * The CTA primary button will fill the container space.
 * The top and bottom padding of text is fixed at 16pt.
 * As the width of the button fills the container, the side paddings will adjust.
 * Text must never exceed one line.
 * */
const CTA = (0, styled_components_1.default)(Primary_1.default) `
  ${exports.CTABaseStyles}
`;
exports.default = CTA;
//# sourceMappingURL=index.js.map